<template>
  <modal title="Log out on other devices">
    <template #body>
      <p>
        This will end {{ count }} other session(s). This won't affect the current session.
      </p>
      <div class="form-group">
        <label for="password_confirmation">
          Confirm password
        </label>
        <input
          id="password_confirmation"
          v-model="password"
          name="password_confirmation"
          type="password"
          class="form-control"
        >
      </div>
    </template>
    <template #footer>
      <button
        :disabled="!password || password.length === 0"
        class="btn btn--primary"
        @click.prevent="handleClick(true)"
      >
        Confirm
      </button>
      <button
        class="btn"
        @click.prevent="handleClick(false)"
      >
        Cancel
      </button>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    title: String,
    count: Number,
    callback: Function,
  },

  data() {
    return {
      password: null,
    }
  },

  methods: {
    handleClick(value) {
      if (!value) {
        this.callback()
      } else {
        this.callback(this.password)
      }

      this.$store.dispatch('clearModal')
    },
  },
}
</script>